<template>
    <standard-modal
        :title="lang('Logga in på Mina sidor', 'Log in to My Pages')"
        name="login-modal"
        :width="680"
        :hide-action-buttons="true"
        @before-open="beforeOpen"
    >
        <!--        <p class="-mt-lg mb-2xl text-neutral-dark hidden md:block">{{ lang('Välj ett av alternativen','Choose one of the options') }}.</p>-->

        <div class="flex flex-col md:flex-row">
            <div class="w-full md:w-1/2 mx-auto">
                <bank-id-auth />
            </div>
            <!--            <button-->
            <!--                v-if="isMobileDevice && ! showStandardLoginForm"-->
            <!--                class="login-form-btn link text-xs font-semibold text-neutral-dark px-xl md:hidden"-->
            <!--                style="max-width: 50ch;"-->
            <!--                @click="showForm"-->
            <!--            >-->
            <!--                {{ lang('Vill du logga in med kundnummer eller personnummer? Klicka här', 'Would you like to sign in with your customer number or social security number? Click here') }}-->
            <!--            </button>-->
            <!--            <div class="w-1/2 pl-3xl border-l border-neutral-light hidden md:inline-flex">-->
            <!--                <form-->
            <!--                    v-loading="loading"-->
            <!--                    :action="actionUrl"-->
            <!--                    method="POST"-->
            <!--                    class="w-full mb-0"-->
            <!--                >-->
            <!--                    <slot name="standard-login-form" />-->
            <!--                </form>-->
            <!--            </div>-->
            <!--            <div-->
            <!--                v-if="showStandardLoginForm"-->
            <!--                class="w-full md:hidden"-->
            <!--            >-->
            <!--                <hr class="my-2xl bg-neutral-light">-->
            <!--                <form-->
            <!--                    v-loading="loading"-->
            <!--                    :action="actionUrl"-->
            <!--                    method="POST"-->
            <!--                >-->
            <!--                    <slot name="standard-login-form" />-->
            <!--                </form>-->
            <!--            </div>-->
        </div>

        <hr class="my-2xl bg-neutral-light md:hidden">

        <div class="flex flex-col -mx-2xl -mb-2xl md:flex-row md:justify-between md:bg-neutral-lighter mt-5xl md:mt-3xl p-2xl">
            <span class="text-xs md:text-md text-center md:text-left">{{ lang('Vill du gå till vår webmail eller telefonicenter','Do you want to visit our webmail or phone center') }}?</span>
            <div class="flex justify-between mt-lg md:mt-0 md:justify-start text-sm md:text-md">
                <a href="https://webmail.ownit.nu" class="link is-blue md:pl-xl">{{ lang('Webmail','Webmail') }}</a>
                <a href="https://tc.ownit.se" class="link is-blue pl-xl">{{ lang('Telefonicenter','Phone center') }}</a>
            </div>
        </div>
    </standard-modal>
</template>

<script>
    export default {
        data() {
            return {
                redirectBack: false,
                loading: false,
                showStandardLoginForm: false,
            };
        },
        computed: {
            actionUrl() {
                const params = this.redirectBack ? { redirect: window.location.href } : {};
                return route('front.login', params);
            },
            csrfToken() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
            isMobileDevice() {
                return utils.isMobileDevice();
            },
        },
        methods: {
            beforeOpen(event) {
                if (event.params) {
                    this.redirectBack = event.params.redirectBack;
                }
            },
            showForm() {
                this.showStandardLoginForm = ! this.showStandardLoginForm;
            },
        },
    };
</script>
